export default __webpack_public_path__ + "static/media/pic3.5bdbc4ae.png";